import { render, staticRenderFns } from "./PriceLogs.vue?vue&type=template&id=b543305a&"
import script from "./PriceLogs.vue?vue&type=script&lang=js&"
export * from "./PriceLogs.vue?vue&type=script&lang=js&"
import style0 from "./PriceLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports